import styled from '@emotion/styled';

export const SearchIconWrapper = styled.div<{ showClearable: boolean }>`
  position: absolute;
  top: 49%;
  right: 14px;
  transform: translateY(-50%);
`;

export const ClearIconWrapper = styled.div`
  position: absolute;
  top: 10px;
  right: 48px;
  background-color: var(--color-ui-grayscale-gray-300);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  background-position: center;
`;
